import { CONFIG } from '@/api/constant/constant.js'
import { listConfigByKeys } from '@/api/system/config.js'

const useConfigStore = defineStore(
  'config',
  {
    state: () => ({
      configInfo: {}, // 配置信息
      configList: [], // 配置列表
    }),
    actions: {
      init() {
        const configKeys = Object.values(CONFIG);
        listConfigByKeys(configKeys).then(res => {
          if (res?.code === 200) {
            this.configList = res.data;
            res.data.forEach(item => {
              this.configInfo[item.configKey] = item.configValue
            })
          }
        })
      }
    }
  })

export default useConfigStore
